<template>
  <div class="layers-panel">
    <div class="layers-buttons">
      <button
        :id="name"
        @click="$emit('onLayerButtonClick', name)"
        :key="name"
        :disabled="isDisabled(name)"
        v-for="{ name, tooltip } in buttons"
        class="layers-icon-button"
      >
        <img :src="getImage(name)" />
        <main-tooltip :tooltipValue="tooltip" :target="name" />
      </button>
    </div>

    <div class="layers-panel-dropdown">
      <button @click="isDropdownOpened = !isDropdownOpened" class="layers-panel-dropdown-button">
        Слои
        <img class="layers-panel-icon" src="../files/arrow-down-gray-icon.svg" alt="arrow down" />
      </button>

      <ul :class="['layers-panel-list', { 'layers-panel-list_opened': isDropdownOpened }]">
        <li class="layers-panel-list-item" :key="item.value" v-for="item in dropdownItems">
          <custom-checkbox
            @input="handleCheckboxChange(item.id, $event)"
            :labelText="item.label"
            :id="item.id"
            :value="Boolean(layers[item.id])"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Checkbox from "../components/ui/Checkbox.vue";
import MainTooltip from "./ui/MainTooltip.vue";

export default {
  data() {
    return {
      SUCCESS_STATUS: 2,
      WARNING_STATUS: 4,
      buttons: [
        { tooltip: "Загрузить подложку", name: "substrate-upload" },
        { tooltip: "Использовать карту", name: "map-upload" },
        { tooltip: "Установить масштаб", name: "set-scale" },
        { tooltip: "Линейка", name: "ruler" },
        { tooltip: "Определить значение параметра в точке", name: "get-risk" },
      ],
      isDropdownOpened: false,
      dropdownItems: [
        { id: "substrate", label: "Подложка" },
        { id: "installations", label: "Установки" },
        { id: "pipelines", label: "Трубопроводы" },
        { id: "dikings", label: "Обвалования" },
        { id: "people", label: "Персонал" },
        { id: "buildings", label: "Селитебные объекты" },
        { id: "firewalls", label: "Противопожарные стены" },
        { id: "solid", label: "Твердая горючая нагрузка" },
        { id: "zones", label: "Поля ОФП и риска" },
      ],
    };
  },
  props: {
    layers: Object,
    projectStatus: [Number, String],
  },
  components: {
    "custom-checkbox": Checkbox,
    MainTooltip,
  },
  created() {
    document.addEventListener("keyup", this.handleClose);
  },
  beforeDestroy() {
    document.removeEventListener("keyup", this.handleClose);
  },
  methods: {
    handleClose(evt) {
      if (evt.key === "Escape") {
        this.$bvToast.hide(this.name);
      }
    },
    getImage(name) {
      return require("../files/" + name + "-icon.svg");
    },
    handleCheckboxChange(layerId, checked) {
      this.$emit("onDropdownChange", { [layerId]: checked });
    },
    isDisabled(name) {
      if (name !== "get-risk") {
        return false;
      }
      return !(this.projectStatus == this.SUCCESS_STATUS || this.projectStatus == this.WARNING_STATUS);
    },
  },
};
</script>

<style scoped>
.layers-panel {
  position: absolute;
  z-index: 10;
  top: 16px;
  right: 16px;
  display: flex;
  align-items: center;
  gap: 11px;
}
.layers-buttons {
  display: flex;
  align-items: center;
  gap: 11px;
}
.layers-icon-button {
  width: 36px;
  height: 36px;
  border-radius: 4px;
  border: 1px solid var(--secondary-color);
  background: var(--white-color);
}
.layers-icon-button:disabled {
  filter: grayscale(100%);
}
.layers-panel-dropdown-button {
  display: flex;
  align-items: center;
  height: 36px;
  padding: 0 8px;
  border-radius: 4px;
  border: 1px solid var(--border-color);
  background: var(--white-color);
}

.layers-panel-icon {
  margin-left: 8px;
}

.layers-panel-list {
  position: absolute;
  background-color: var(--white-color);
  right: 0;
  top: 36px;
  z-index: 1;
  padding: 0;
  border-radius: 4px;
  max-height: 0;
  overflow: hidden;
}
.layers-panel-list_opened {
  max-height: 500px;
  padding: 12px;
  border: 1px solid var(--border-color);
}
.layers-panel-list-item {
  margin-bottom: 12px;
}
.layers-panel-list-item:last-of-type {
  margin-bottom: 0;
}
</style>
